import { flex } from '@byecode/ui'
import styled from 'styled-components'

export const Contain = styled.div`
    /* width: 100%; */
    ${flex}
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    /* padding: 0 16px 4px 16px; */
`

export const Content = styled.div`
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 12px;
`
